import React, { useState } from 'react';
import { Lock, Check } from 'lucide-react';
import chatApi from '../../../services/chatApi';
import { useAuth } from '../../../context/AuthContext';

const PasswordResetCard = ({ data, onAction }) => {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setError('At least 8 characters'); return; }
    if (pw !== pw2) { setError('Passwords don\'t match'); return; }
    setLoading(true); setError(null);
    try {
      const res = await chatApi.resetPassword(data.token, pw);
      const { token, user, forma_messages } = res.data;
      localStorage.setItem('hpme_token', token);
      auth?.loginFromResponse?.(token, user);
      onAction?.({ type: 'auth_success', payload: { user, messages: forma_messages || [] } });
    } catch (err) {
      setError(err.response?.data?.detail || 'Reset failed');
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-3 rounded-sm border border-zinc-700 bg-zinc-900/60 p-4" data-testid="card-password-reset">
      <div className="flex items-center gap-2 bg-zinc-950 border border-zinc-700 rounded-sm px-3 py-2">
        <Lock className="w-4 h-4 text-zinc-500" />
        <input autoFocus type="password" className="bg-transparent outline-none flex-1 text-sm text-white" placeholder="New password (8+ chars)"
          value={pw} onChange={e => setPw(e.target.value)} required data-testid="reset-pw-input" />
      </div>
      <div className="flex items-center gap-2 bg-zinc-950 border border-zinc-700 rounded-sm px-3 py-2">
        <Lock className="w-4 h-4 text-zinc-500" />
        <input type="password" className="bg-transparent outline-none flex-1 text-sm text-white" placeholder="Confirm password"
          value={pw2} onChange={e => setPw2(e.target.value)} required data-testid="reset-pw-confirm-input" />
      </div>
      {error && <p className="text-red-400 text-xs">{error}</p>}
      <button type="submit" disabled={loading}
        className="flex items-center justify-center gap-2 w-full bg-primary text-black font-secondary font-bold py-2 rounded-sm disabled:opacity-50 text-sm"
        data-testid="reset-submit-btn">
        <Check className="w-4 h-4" />{loading ? 'Updating…' : 'Set new password'}
      </button>
    </form>
  );
};

export default PasswordResetCard;
